import Loader from '@byma/shared/components/Loader'
import Input from '@byma/shared/components/Input'
import { useState, useEffect } from 'react'
import useAuth from '@byma/shared/hooks/useAuth'
import dayjs from 'dayjs'
import useSWR, { useSWRConfig } from 'swr'
import fetcher from '@byma/shared/helpers/fetcher'
 
function GatewaySessionItem({gatewaySession, active=false, noCheckbox=false}) {
    return (
        <div className={`flex items-center cursor-pointer box box-hover ${active && 'box-active'} space-x-3 mb-0`}>
            {!noCheckbox && (
                <input type="checkbox" checked={active} readOnly />
            )}
            <div className="">
                <p className="text-md font-bold">{gatewaySession.name}</p>
                <p className="text-sm">{dayjs(gatewaySession.created_at).format('DD/MM/YYYY [às] hh:mm')}</p>
            </div>
        </div>
    )
}
export default function GatewaySessionSelector({eventId='', selectedGatewaySessions=[], onChange}) {
    const session = useAuth()
    const { token, user: currentUser } = session
    const { data: gatewaySessions } = useSWR(token ? [`/api/gatewaySessions/getAll?perPage=60&partyIds=${eventId}`, null, token] : null, fetcher)
    const [ isLoading, setIsLoading ] = useState(false)

    function toggle(gatewaySession) {
        if (selectedGatewaySessions?.indexOf(gatewaySession._id) >= 0) {
            return onChange(selectedGatewaySessions.filter(id => id !== gatewaySession._id))
        } else {
            return onChange([...selectedGatewaySessions, gatewaySession._id])
        }
    }

    if (isLoading) {
        return (
            <div className="box flex flex-col justify-center items-center">
                <Loader />
                <p className="text-sm">Buscando sessão...</p>
            </div>
        )
    }

    useEffect(() => {
        if (gatewaySessions?.result?.length === 1 && selectedGatewaySessions?.length === 0) {
            onChange([gatewaySessions.result[0]._id])
        }
    }, [gatewaySessions])


    return (
        <div className="flex flex-col justify-between p-3 space-y-3 h-60 overflow-y-auto box w-full">

            <div className="overflow-y-auto flex-grow flex-shrink h-full">
                <div className="flex flex-col h-full space-y-3">
                    { gatewaySessions ? gatewaySessions.result.map(gatewaySession => (
                        <div onClick={() => toggle(gatewaySession)}>
                            <GatewaySessionItem gatewaySession={gatewaySession} active={selectedGatewaySessions?.indexOf(gatewaySession._id) >= 0} />
                        </div>
                    )) : <Loader />}
                </div>
            </div>
        </div>
    )
}
